import { render, staticRenderFns } from "./modal-box.vue?vue&type=template&id=14f87f14&scoped=true&"
import script from "./modal-box.vue?vue&type=script&lang=js&"
export * from "./modal-box.vue?vue&type=script&lang=js&"
import style0 from "./modal-box.vue?vue&type=style&index=0&id=14f87f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f87f14",
  null
  
)

export default component.exports